export default {
  // To Chris:
  // you can try to move some of your date format functions here in the future
  // then you can call them in page like: Utils.date.toLongString(couse.start_date)
  // If we change style, logic, we do not need to search in all pages to change,
  // we can just change one function here
};
